'use client';

import { useTouchPrimary } from '@/hooks/use-has-primary-touch';
import { useMediaQuery } from '@/hooks/use-media-query';

/** Leave room for navigation, the 420px chat pane, and a usable artifact pane. */
export function useArtifactDrawerLayout(): boolean {
  const touchPrimary = useTouchPrimary();
  const narrowViewport = useMediaQuery('(max-width: 1023px)');
  return touchPrimary || narrowViewport;
}
